
import * as plotUtil from '../plot_util'

const double_arrow_opts = {
    headHeightFactor: 0.25,
    headWidthFactor: 0.3,
    neckHeightFactor: 0.85,
    neckWidthFactor: 0.15,
    fixPointCount: 4,
}

const HALF_PI = Math.PI / 2

const getTempPoint4 = function (linePnt1, linePnt2, point) {
    let midPnt = plotUtil.mid(linePnt1, linePnt2);
    let len = plotUtil.distance(midPnt, point);
    let angle = plotUtil.getAngleOfThreePoints(linePnt1, midPnt, point);
    let symPnt, distance1, distance2, mid;
    if (angle < HALF_PI) {
        distance1 = len * Math.sin(angle);
        distance2 = len * Math.cos(angle);
        mid = plotUtil.getThirdPoint(linePnt1, midPnt, HALF_PI, distance1, false);
        symPnt = plotUtil.getThirdPoint(midPnt, mid, HALF_PI, distance2, true);
    }
    else if (angle >= HALF_PI && angle < Math.PI) {
        distance1 = len * Math.sin(Math.PI - angle);
        distance2 = len * Math.cos(Math.PI - angle);
        mid = plotUtil.getThirdPoint(linePnt1, midPnt, HALF_PI, distance1, false);
        symPnt = plotUtil.getThirdPoint(midPnt, mid, HALF_PI, distance2, false);
    }
    else if (angle >= Math.PI && angle < Math.PI * 1.5) {
        distance1 = len * Math.sin(angle - Math.PI);
        distance2 = len * Math.cos(angle - Math.PI);
        mid = plotUtil.getThirdPoint(linePnt1, midPnt, HALF_PI, distance1, true);
        symPnt = plotUtil.getThirdPoint(midPnt, mid, HALF_PI, distance2, true);
    }
    else {
        distance1 = len * Math.sin(Math.PI * 2 - angle);
        distance2 = len * Math.cos(Math.PI * 2 - angle);
        mid = plotUtil.getThirdPoint(linePnt1, midPnt, HALF_PI, distance1, true);
        symPnt = plotUtil.getThirdPoint(midPnt, mid, HALF_PI, distance2, false);
    }
    return symPnt;
};

const getArrowPoints = function (pnt1, pnt2, pnt3, clockWise) {
    let midPnt = plotUtil.mid(pnt1, pnt2);
    let len = plotUtil.distance(midPnt, pnt3);
    let midPnt1 = plotUtil.getThirdPoint(pnt3, midPnt, 0, len * 0.3, true);
    let midPnt2 = plotUtil.getThirdPoint(pnt3, midPnt, 0, len * 0.5, true);
    //let midPnt3=PlotUtils.getThirdPoint(pnt3, midPnt, 0, len * 0.7, true);
    midPnt1 = plotUtil.getThirdPoint(midPnt, midPnt1, HALF_PI, len / 5, clockWise);
    midPnt2 = plotUtil.getThirdPoint(midPnt, midPnt2, HALF_PI, len / 4, clockWise);
    //midPnt3=PlotUtils.getThirdPoint(midPnt, midPnt3, Constants.HALF_PI, len / 5, clockWise);

    let points = [midPnt, midPnt1, midPnt2, pnt3];
    // 计算箭头部分
    let arrowPnts = getArrowHeadPoints(points, double_arrow_opts.headHeightFactor, double_arrow_opts.headWidthFactor, double_arrow_opts.neckHeightFactor, double_arrow_opts.neckWidthFactor);
    let neckLeftPoint = arrowPnts[0];
    let neckRightPoint = arrowPnts[4];
    // 计算箭身部分
    let tailWidthFactor = plotUtil.distance(pnt1, pnt2) / plotUtil.getBaseLength(points) / 2;
    let bodyPnts =getArrowBodyPoints(points, neckLeftPoint, neckRightPoint, tailWidthFactor);
    let n = bodyPnts.length;
    let lPoints = bodyPnts.slice(0, n / 2);
    let rPoints = bodyPnts.slice(n / 2, n);
    lPoints.push(neckLeftPoint);
    rPoints.push(neckRightPoint);
    lPoints = lPoints.reverse();
    lPoints.push(pnt2);
    rPoints = rPoints.reverse();
    rPoints.push(pnt1);
    return lPoints.reverse().concat(arrowPnts, rPoints);
};


const getArrowHeadPoints = function (points, tailLeft, tailRight) {
    let len = plotUtil.getBaseLength(points);
    let headHeight = len * double_arrow_opts.headHeightFactor;
    let headPnt = points[points.length - 1];
    let tailWidth = plotUtil.distance(tailLeft, tailRight);
    let headWidth = headHeight * double_arrow_opts.headWidthFactor;
    let neckWidth = headHeight * double_arrow_opts.neckWidthFactor;
    let neckHeight = headHeight * double_arrow_opts.neckHeightFactor;
    let headEndPnt = plotUtil.getThirdPoint(points[points.length - 2], headPnt, 0, headHeight, true);
    let neckEndPnt = plotUtil.getThirdPoint(points[points.length - 2], headPnt, 0, neckHeight, true);
    let headLeft = plotUtil.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, false);
    let headRight = plotUtil.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, true);
    let neckLeft = plotUtil.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, false);
    let neckRight = plotUtil.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, true);
    return [neckLeft, headLeft, headPnt, headRight, neckRight];
};

const getArrowBodyPoints = function (points, neckLeft, neckRight, tailWidthFactor) {
    let allLen = plotUtil.wholeDistance(points);
    let len = plotUtil.getBaseLength(points);
    let tailWidth = len * tailWidthFactor;
    let neckWidth = plotUtil.distance(neckLeft, neckRight);
    let widthDif = (tailWidth - neckWidth) / 2;
    let tempLen = 0, leftBodyPnts = [], rightBodyPnts = [];
    for (let i = 1; i < points.length - 1; i++) {
        let angle = plotUtil.getAngleOfThreePoints(points[i - 1], points[i], points[i + 1]) / 2;
        tempLen += plotUtil.distance(points[i - 1], points[i]);
        let w = (tailWidth / 2 - tempLen / allLen * widthDif) / Math.sin(angle);
        let left = plotUtil.getThirdPoint(points[i - 1], points[i], Math.PI - angle, w, true);
        let right = plotUtil.getThirdPoint(points[i - 1], points[i], angle, w, false);
        leftBodyPnts.push(left);
        rightBodyPnts.push(right);
    }
    return leftBodyPnts.concat(rightBodyPnts);
};

export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    let [pnt1, pnt2, pnt3] = coordinates
    let count = coordinates.length;
    let tempPoint4, connPoint;
    if (count == 3)
        tempPoint4 = getTempPoint4(pnt1, pnt2, pnt3);
    else
        tempPoint4 = coordinates[3];
    if (count == 3 || count == 4)
        connPoint = plotUtil.mid(pnt1, pnt2);
    else
        connPoint = dcoordinate[4];
    let leftArrowPnts, rightArrowPnts;
    if (plotUtil.isClockWise(pnt1, pnt2, pnt3)) {
        leftArrowPnts = getArrowPoints(pnt1, connPoint, tempPoint4, false);
        rightArrowPnts = getArrowPoints(connPoint, pnt2, pnt3, true);
    } else {
        leftArrowPnts = getArrowPoints(pnt2, connPoint, pnt3, false);
        rightArrowPnts = getArrowPoints(connPoint, pnt1, tempPoint4, true);
    }
    let m = leftArrowPnts.length;
    let t = (m - 5) / 2;

    let llBodyPnts = leftArrowPnts.slice(0, t);
    let lArrowPnts = leftArrowPnts.slice(t, t + 5);
    let lrBodyPnts = leftArrowPnts.slice(t + 5, m);

    let rlBodyPnts = rightArrowPnts.slice(0, t);
    let rArrowPnts = rightArrowPnts.slice(t, t + 5);
    let rrBodyPnts = rightArrowPnts.slice(t + 5, m);

    rlBodyPnts = plotUtil.getBezierPoints(rlBodyPnts);
    let bodyPnts = plotUtil.getBezierPoints(rrBodyPnts.concat(llBodyPnts.slice(1)));
    lrBodyPnts = plotUtil.getBezierPoints(lrBodyPnts);

    let pnts = rlBodyPnts.concat(rArrowPnts, bodyPnts, lArrowPnts, lrBodyPnts);
    return [pnts]
}